import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { REPORT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { AppVersionCheckPage } from '@/features/appVersionCheck/pages/AppVersionCheckPage';
import { appVersionCheckSearchSchema } from '@/features/appVersionCheck/types/appVersionCheck.types';

export const Route = createFileRoute('/_auth/reports/app-version-check')({
  beforeLoad: () => requirePermission(REPORT_PERMISSIONS.APP_VERSION_VIEW),
  validateSearch: appVersionCheckSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="App Version Check">
      <Suspense fallback={<PageLoader />}>
        <AppVersionCheckPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
